var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Pattern")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._v("\n            Hello\n        ")])])])
}]

export { render, staticRenderFns }